import {useGetData} from '../../src/apiservice/apiCall'


export function useGallery(){
	return useGetData('/api/WebApi/GetGallery')
}
